var JWTClaimNames_1, JWTClaimPermittedValuesList_1, TNAuthorizationList_1;
import { __decorate } from "tslib";
import * as asn from "@peculiar/asn1-schema";
const id_pkix = "1.3.6.1.5.5.7";
export const id_pe = `${id_pkix}.1`;
export const id_ad = `${id_pkix}.48`;
export const id_pe_JWTClaimConstraints = `${id_pe}.27`;
let JWTClaimNames = JWTClaimNames_1 = class JWTClaimNames extends asn.AsnArray {
    constructor(items) {
        super(items);
        Object.setPrototypeOf(this, JWTClaimNames_1.prototype);
    }
};
JWTClaimNames = JWTClaimNames_1 = __decorate([
    asn.AsnType({
        type: asn.AsnTypeTypes.Sequence,
        itemType: asn.AsnPropTypes.IA5String,
    })
], JWTClaimNames);
export { JWTClaimNames };
export class JWTClaimPermittedValues {
    constructor(params = {}) {
        this.claim = "";
        this.permitted = [];
        Object.assign(this, params);
    }
}
__decorate([
    asn.AsnProp({
        type: asn.AsnPropTypes.IA5String,
    })
], JWTClaimPermittedValues.prototype, "claim", void 0);
__decorate([
    asn.AsnProp({
        type: asn.AsnPropTypes.Utf8String,
        repeated: "sequence",
    })
], JWTClaimPermittedValues.prototype, "permitted", void 0);
let JWTClaimPermittedValuesList = JWTClaimPermittedValuesList_1 = class JWTClaimPermittedValuesList extends asn.AsnArray {
    constructor(items) {
        super(items);
        Object.setPrototypeOf(this, JWTClaimPermittedValuesList_1.prototype);
    }
};
JWTClaimPermittedValuesList = JWTClaimPermittedValuesList_1 = __decorate([
    asn.AsnType({
        type: asn.AsnTypeTypes.Sequence,
        itemType: JWTClaimPermittedValues,
    })
], JWTClaimPermittedValuesList);
export { JWTClaimPermittedValuesList };
export class JWTClaimConstraints {
    constructor(params = {}) {
        Object.assign(this, params);
    }
}
__decorate([
    asn.AsnProp({
        type: JWTClaimNames,
        optional: true,
        context: 0,
    })
], JWTClaimConstraints.prototype, "mustInclude", void 0);
__decorate([
    asn.AsnProp({
        type: JWTClaimPermittedValuesList,
        optional: true,
        context: 1,
    })
], JWTClaimConstraints.prototype, "permittedValues", void 0);
export const id_pe_TNAuthList = `${id_pe}.26`;
export class TelephoneNumberRange {
    constructor() {
        this.start = "";
        this.count = 2;
    }
}
__decorate([
    asn.AsnProp({ type: asn.AsnPropTypes.IA5String })
], TelephoneNumberRange.prototype, "start", void 0);
__decorate([
    asn.AsnProp({ type: asn.AsnPropTypes.Integer })
], TelephoneNumberRange.prototype, "count", void 0);
let TNEntry = class TNEntry {
    constructor(params = {}) {
        Object.assign(this, params);
    }
};
__decorate([
    asn.AsnProp({
        type: asn.AsnPropTypes.IA5String,
        context: 0,
    })
], TNEntry.prototype, "spc", void 0);
__decorate([
    asn.AsnProp({
        type: TelephoneNumberRange,
        context: 1,
    })
], TNEntry.prototype, "range", void 0);
__decorate([
    asn.AsnProp({
        type: asn.AsnPropTypes.IA5String,
        context: 2,
    })
], TNEntry.prototype, "one", void 0);
TNEntry = __decorate([
    asn.AsnType({
        type: asn.AsnTypeTypes.Choice,
    })
], TNEntry);
export { TNEntry };
let TNAuthorizationList = TNAuthorizationList_1 = class TNAuthorizationList extends asn.AsnArray {
    constructor(items) {
        super(items);
        Object.setPrototypeOf(this, TNAuthorizationList_1.prototype);
    }
};
TNAuthorizationList = TNAuthorizationList_1 = __decorate([
    asn.AsnType({
        type: asn.AsnTypeTypes.Sequence,
        itemType: TNEntry,
    })
], TNAuthorizationList);
export { TNAuthorizationList };
export const id_ad_stirTNList = `${id_ad}.14`;
